module.exports = __webpack_public_path__ + "static/media/AmazonFireTv.b44bc302.svg";